import React, { useState, useContext } from 'react';
import { track } from '@vercel/analytics';
import { AuthContext } from '../AuthContext';
import '../styles/Feedback.scss';
import logger from '../utils/logger';
import { useNavigate } from 'react-router-dom';

function Feedback() {
  const { authToken } = useContext(AuthContext);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [feedbackCategory, setFeedbackCategory] = useState('Feedback on the App Functionality');
  const [feedbackText, setFeedbackText] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    logger.info("Submitting feedback:", {
      feedbackText,
      feedbackCategory
    });
    
    if (!feedbackText.trim()) {
      alert("Please enter feedback before submitting.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken.startsWith('Bearer ') ? authToken : `Bearer ${authToken}`
        },
        body: JSON.stringify({
          feedback: feedbackText,        // user_feedback in backend
          category: feedbackCategory,    // category in backend
          question: "",                  // empty for standalone feedback
          answer: "",                    // empty for standalone feedback
          result: ""                     // empty for standalone feedback
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        logger.error('Feedback Error:', response.status, errorText);
        throw new Error('Error submitting feedback');
      }

      const data = await response.json();
      alert(data.message);
      setFeedbackSubmitted(true);
      
      // Analytics tracking
      track('feedback_submitted', {
        category: feedbackCategory,
        from_page: 'dedicated_feedback_page'
      });
    } catch (error) {
      logger.error(error);
      alert("Failed to submit feedback. Please try again.");
    }
  };

  return (
    <div className="feedback-page">
      <div className="feedback-container">
        <button onClick={handleBack} className="back-button">
          &larr; Back to Home
        </button>
        <h1>Tell Us What You Think!</h1>
        <p className="feedback-intro">
          We value your feedback and are committed to making Pulc the best educational tool possible. 
          Please share your thoughts, suggestions, or report any issues you've encountered.
        </p>
        
        <div className="feedback-section">
          {!feedbackSubmitted ? (
            <form onSubmit={handleFeedbackSubmit} className="feedback-form">
              <label className="feedback-label">
                Feedback Category:
                <select
                  value={feedbackCategory}
                  onChange={(e) => setFeedbackCategory(e.target.value)}
                  className="feedback-select"
                  required
                >
                  <option value="Feedback on the App Functionality">Feedback on the App Functionality</option>
                  <option value="Feedback on my Results">Feedback on my Results</option>
                  <option value="Suggest a Feature">Suggest a Feature</option>
                  <option value="Other">Other</option>
                </select>
              </label>

              <textarea
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                placeholder="Please share your thoughts, suggestions, or report any issues..."
                spellCheck="false"
                className="feedback-textarea"
              />
              <button type="submit" className="feedback-submit-button">
                Submit Feedback
              </button>
            </form>
          ) : (
            <div className="thank-you-message">
              <h2>Thank You for Your Feedback!</h2>
              <p>We appreciate you taking the time to help us improve Pulc.</p>
              <div className="feedback-buttons">
                <button 
                  className="feedback-submit-button"
                  onClick={() => {
                    setFeedbackSubmitted(false);
                    setFeedbackText("");
                  }}>
                  Submit Another Comment
                </button>
                <button 
                  className="back-button"
                  onClick={handleBack}>
                  Return to Home
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Feedback; 